import { FC, useCallback } from "react";
import "./MultiSelect.scss";

export type MultiSelectCheckedMap = Record<string, boolean>;

export interface MultiSelectItem {
    readonly id: string;
    readonly title: string;
}

export interface MultiSelectProps {
    readonly items: readonly MultiSelectItem[];
    readonly checked: MultiSelectCheckedMap;
    onChange(checked: MultiSelectCheckedMap): void;
}

export const MultiSelect: FC<MultiSelectProps> = (props) => {
    const { items, checked, onChange } = props;

    const handleToggle = useCallback(
        (ev: React.ChangeEvent<HTMLInputElement>) => {
            const id = ev.target.value;
            onChange({
                ...checked,
                [id]: !checked[id],
            });
        },
        [checked, onChange]
    );

    return (
        <ul className="xappw-multiselect">
            {items?.map((item) => (
                <li key={item.id}>
                    <label>
                        <input
                            type="checkbox"
                            checked={checked[item.id] || false}
                            onChange={handleToggle}
                            value={item.id}
                        />
                        <span>{item.title}</span>
                    </label>
                </li>
            ))}
        </ul>
    );
};
